<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <l-auth-button type="primary" auth="admin_user_create_btn" @click="add_visible = true"> 新增</l-auth-button>
      <div class="l-simple-search-container">
        <el-input placeholder="姓名/手机号" v-model="search_data.keywords" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>

        <div class="l-show-more-search" @click="showSearch">
          <!-- <i-find theme="outline" size="20" :strokeWidth="3" /> -->
          <span>高级搜索</span>
        </div>
      </div>
    </div>
    <div class="l-primary l-table-config">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>选择固定栏位
        </span>

        <div class="">
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              选择固定栏位
              <a style="float:right;  color: red;" @click="resetFixedCheck">重置</a>
            </div>

            <!-- <div class="l-table-column-fixed-select-reset-btn" @click="resetFixedCheck">重置</div> -->

          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">
                {{item.label}}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>

      </el-popover>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column v-for="(item,index) in columns" :key="index" v-bind="{...item}" :label="item.label" show-overflow-tooltip>
        <template v-slot="{row}">

          
          <template v-if="item.prop=='role_name'">
            <el-tag size="small" type="success">
              {{row.role_names}}
            </el-tag>
          </template>

<template v-if="item.prop=='street_names'">
             <el-tag size="small" type="danger" disable-transitions v-for="(item,idx) in row.street_name" :key="idx"> 
            {{item}}
            </el-tag>
          </template>

          <template v-if="item.prop=='community_names'">
             <el-tag  style="border-color :white" size="small" type="danger" disable-transitions v-for="(item,idx) in row.community_name" :key="idx"> 
            {{item}}
            </el-tag>
          </template>

            <template v-if="item.prop=='place_type_names'">
             <el-tag size="small" type="danger" disable-transitions v-for="(item,idx) in row.place_type_name" :key="idx"> 
            {{item}}
            </el-tag>
          </template>

          <template v-else-if="item.prop=='state'">
            <!-- <el-tag :type="row.state == STATES.enabled ? 'success' : 'danger'" size="small" @click="() => changeState(row)" disable-transitions>{{ STATE_NAMES[row.state] }}</el-tag> -->
            <el-tag :type="row.state == STATES.enabled ? 'success' : 'danger'" size="small" disable-transitions>{{ STATE_NAMES[row.state] }}</el-tag>
          </template>
          <template v-else-if="item.prop=='email'">
            {{emailFormat(row.email)}}
          </template>

          <template v-else-if="item.prop=='mobile'">
            {{phoneFormat(row.mobile)}}
          </template>

          <template v-else>
            {{row[item.prop]}}
          </template>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="240" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="admin_user_info_btn" @click="showInfo(row.aid)"><i class="el-icon-warning-outline"></i>详情</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="admin_user_edit_btn" @click="showEdit(row.aid)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="admin_user_del_btn" @click="del(row.aid)"><i class="el-icon-delete"></i> 删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--高级搜索-->
    <!-- <el-drawer :title="getLang('高级搜索')" class="l-search-drawer" :modal="false" :visible.sync="search_visible" size="500px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
        <div class="l-search-drawer-body" v-loading="search_loading">
          <el-form label-width="80px" ref="search_form" :model="search_data">
            <el-form-item :label="getLang('姓名')" prop="name">
              <el-input v-model="search_data.name" clearable :placeholder="getLang('请输入姓名')"></el-input>
            </el-form-item>
            <el-form-item :label="getLang('手机号')" prop="mobile">
              <el-input v-model="search_data.mobile" clearable :placeholder="getLang('请输入手机号')"></el-input>
            </el-form-item>
            <el-form-item :label="getLang('职位')" prop="role_id">
              <el-select v-model="search_data.role_id" :placeholder="getLang('请选择职位(可多选)')" clearable filterable>
                <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="getLang('启用标识')" prop="state">
              <el-select v-model="search_data.state" :placeholder="getLang('启用标识')" clearable>
                <el-option :label="getLang('启用')" :value="1">
                </el-option>
                <el-option :label="getLang('禁用')" :value="0">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div class="l-search-drawer-footer">
          <el-button type="normal" @click="onReset">{{getLang('重置')}}</el-button>
          <el-button type="primary" @click="onSearch">{{getLang('搜索')}}</el-button>
        </div>
      </el-drawer> -->

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="创建小程序账号" width="1000px">
      <l-user-edit @on-success="onAddSucess" :visible.sync="add_visible" />
    </l-dialog>

    <l-dialog :visible.sync="edit_visible" title="编辑" width="1000px">
      <l-user-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog>

    <!--修改密码-->
    <l-dialog :visible.sync="change_pwd_visible" title="修改密码">
      <admin-user-change-pwd @on-success="onChangePwdSuccess" :visible.sync="change_pwd_visible" :id="change_pwd_id" />
    </l-dialog>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="详情" width="1100px">
      <l-user-edit :visible.sync="info_visible" :id="info_id" is-info />
    </l-dialog>
  </el-card>
</template>

  <script>
import Vue from "vue";
import Edit from "./Edit";
import UserChangePwd from "@/views/user/ChangePwd";
import { emailFormat, phoneFormat } from "@/utils/Fuc";
import { STATES, STATE_NAMES } from "@/common/constants/resources";

let columns = [
  {
    prop: "index",
    label: "序号",
    fixed: true,
    width: "100",
  },
  {
    prop: "state",
    label: "启用标识",
    fixed: false,
    minWidth: "150",
    // render: (h, { row }) => {
    //     return (
    //       <Tag color={row.state == 1 ? 'success' : 'danger'}>{this.STATE_NAMES[row.state]}</Tag>
    //     );
    // }
    // render: (h, { row }) => {
    //   return (
    //       <el-tag type={row.state == 1 ? 'success' : 'danger'} size="small"
    //         onClick={() => this.changeState(row)}
    //         disable-transitions>{this.STATE_NAMES[row.state]}</el-tag>
    //   )
    // }
  },
  // {
  //   prop: "cust_id",
  //   label: "管理員编号",
  //   fixed: true,
  //   width: "140",
  // },
  {
    prop: "username",
    label: "用户名",
    fixed: true,
    width: "140",
  },
  // {
  //   prop: "email",
  //   label: "邮箱",
  //   fixed: false,
  //   minWidth: "180",
  // },
  {
    prop: "username",
    label: "手机号",
    fixed: false,
    minWidth: "150",
  },
  {
    prop: "name",
    label: "姓名",
    fixed: false,
    minWidth: "120",
  },
  
  {
    prop: "role_name",
    label: "职位",
    fixed: false,
    minWidth: "200",
  },
  {
    prop: "street_names",
    label: "管理的街道",
    fixed: false,
    minWidth: "200",
  },
  {
    prop: "community_names",
    label: "管理的社区",
    fixed: false,
    minWidth: "200",
  },

  {
    prop: "place_type_names",
    label: "管理的场所类型",
    fixed: false,
    minWidth: "200",
  },

  {
    prop: "remark",
    label: "备注",
    fixed: false,
    minWidth: "150",
  },
  {
    prop: "created_at",
    label: "新增时间",
    fixed: false,
    minWidth: "180",
  },

  {
    prop: "created_user_name",
    label: "新增员工",
    fixed: false,
    minWidth: "180",
  },

  {
    prop: "updated_at",
    label: "修改时间",
    fixed: false,
    minWidth: "180",
  },
  {
    prop: "updated_user_name",
    label: "修改员工",
    fixed: false,
    minWidth: "180",
  },
];

export default {
  name: "admin-user",
  components: {
    [Edit.name]: Edit,
    [UserChangePwd.name]: UserChangePwd,
  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      add_visible: false, //是否显示添加

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      info_visible: false, //是否显示编辑
      info_id: 0,

      change_pwd_visible: false, //是否显示修改密码
      change_pwd_id: 0,
      STATE_NAMES: STATE_NAMES,
      STATES: STATES,
      //搜索
      search_visible: false,
      search_loading: true,
      site_tree: [],
      role_list: [],
      search_data: {
        keywords: "",
        name: "",
        mobile: "",
        email: "",
        site_id: undefined,
        role_id: "",
      },
      rel_search_data: {},
      show_more_search: false,

      re_fixed_list: ["index", "state"],
      fixed_list: ["index", "state"],
    };
  },

  computed: {
    columns() {
      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {
    fixed_list(val) {
      if (val.length > 3) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    emailFormat(num) {
      return emailFormat(num);
    },
    phoneFormat(num) {
      return phoneFormat(num);
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("applet_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索数据
    getSearchData() {
      this.search_loading = true;
      this.$_invoke("adminUser_getSearchData")
        .then((ret) => {
          this.site_tree = ret.site_tree;
          this.role_list = ret.role_list;
        })
        .finally(() => {
          this.search_loading = false;
        });
    },

    //显示搜索
    showSearch() {
      this.search_visible = true;
      this.getSearchData();
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //修改状态
    changeState(row) {
      // console.log(row.id);
      this.change_state_loading.push(row.id);

      this.$_invoke(`adminUser_updState`, {
        id: row.id,
        state: row.state,
      })
        .then((ret) => {
          row.state = ret.state;
          this.$_msg.success("修改状态成功");
        })
        .catch((e) => {
         console.log(e);
        })
        .finally(() => { });
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getList();
    },

    //显示修改密码界面
    showChangePwd(id) {
      this.change_pwd_id = id;
      this.$nextTick(() => {
        this.change_pwd_visible = true;
      });
    },

    //修改密码成功回掉
    onChangePwdSuccess() {
      this.change_pwd_visible = false;
    },

    //删除
    del(id) {
      this.$confirm(
        "确定删除该条记录吗" + "？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$_invoke(`applet_delete`, { id: id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },

    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
  },
};
  </script>

